import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickActionButton = ({ icon, label, onClick, color = 'primary' }) => {
  const colorConfig = {
    primary: 'bg-primary/10 text-primary hover:bg-primary/20',
    success: 'bg-success/10 text-success hover:bg-success/20',
    warning: 'bg-warning/10 text-warning hover:bg-warning/20',
    secondary: 'bg-secondary/10 text-secondary hover:bg-secondary/20'
  };

  return (
    <button
      onClick={onClick}
      className={`flex flex-col items-center justify-center gap-2 md:gap-3 p-4 md:p-6 rounded-lg border border-border ${colorConfig?.[color]} transition-smooth hover:shadow-warm-md`}
    >
      <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background flex items-center justify-center">
        <Icon name={icon} size={24} />
      </div>
      <span className="text-sm md:text-base font-medium text-center">
        {label}
      </span>
    </button>
  );
};

export default QuickActionButton;